export default "__VITE_ASSET__7668beca__"